






































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import VueScrollTo from 'vue-scrollto'
import ArticlesFields from '../ArticlesFields.vue'
import CollapsibleItem from '@/components/CollapsibleItem.vue'
import Sortable from '@/directives/sortable'

type SummaryItem = {
  title: string
  article?: any
  synopsis: string
  key?: any
}

@Component({
  components: {
    ArticlesFields,
    CollapsibleItem
  },
  directives: {
    Sortable
  }
})
class DailyEquityNoteArticlesStep extends Vue {
  @Prop({ type: Object, required: true }) draft
  @Prop({ type: Boolean, required: true }) highlightFields

  error = null
  show = true

  items: SummaryItem[] = []

  beforeMount() {
    for (const key in this.draft.steps.summaries) {
      if (this.draft.steps.summaries.hasOwnProperty(key)) {
        const summary = this.draft.steps.summaries[key]
        if (summary?.title || summary?.article || summary?.synopsis) {
          this.items.push({ ...summary, key: Math.random().toString() })
        }
      }
    }
  }

  get sectionTitles() {
    return this.items.map((item, idx) => item?.title || `Summary ${idx + 1}`)
  }

  get articlesKeys() {
    return Object.keys(this.draft.steps.summaries)
  }

  @Emit('update2')
  update() {
    const summaries = {}
    for (const i in this.items) {
      summaries[`article${parseInt(i, 10)+1}`] = this.items[i]
    }
    const draft = {...this.draft}
    draft.steps.summaries = summaries
    return draft
  }

  onDelete(idx) {
    this.items.splice(idx, 1)
    this.update()
  }

  onItemsSort(sort) {
    const item = this.items.splice(sort.oldIndex, 1)
    this.items.splice(sort.newIndex, 0, item[0])
    this.update()
    this.$nextTick(() => {
      this.show = false
      this.$nextTick(() => this.show = true)
    })
  }

  labelsPrefix(id) {
    return `Summary ${id}`
  }

  addTopic() {
    this.items.push({ title: '', synopsis: '', key: Math.random().toString() })
    this.update()

    this.$nextTick(() => {
      const target = document.querySelector(
        `div[data-id="summaries-${this.items.length}"]`
      )
      if (target) {
        VueScrollTo.scrollTo(target, 1000)
      }
    })
  }
}

export default DailyEquityNoteArticlesStep
